<template>
  <div class="device_history_cla">
    <el-row>
      <el-form style="display:flex;margin-top:5px"
               :inline="true"
               :model="params"
               class="demo-form-inline">
        <el-form-item :label="$t('attendanceRecord.dataRange')">
          <el-date-picker class="pickData_cla"
                          v-model="value2"
                          @clear="searchFn"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="-"
                          :start-placeholder="$t('common.startTime')"
                          :end-placeholder="$t('common.endTime')"
                          :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('device.log.methodType')"
                      prop="type">
          <div style="display:flex">
            <zk-dictionary-select type="deviceOperationType"
                                  v-model="params.methodType"></zk-dictionary-select>

          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchFn"
                     icon="el-icon-search"
                     type="primary">{{ $t('com_log.search') }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table
                :data="tableData"
                :expand-row-keys="expands"
                :row-key="getRowKeys">
        <el-table-column type="index"
                         width="50"></el-table-column>

        <el-table-column prop="userName"
                         :label="this.$t('device.log.userName')"></el-table-column>

        <el-table-column prop="companyName"
                         :label="this.$t('device.log.companyName')"></el-table-column>

        <el-table-column prop="createdDate"
                         :label="this.$t('device.log.createdDate')">
          <template slot-scope="scope">
            <span>{{ scope.row.createdDate | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="methodType"
                         :label="this.$t('device.log.methodType')">
          <template slot-scope="scope">
            <zk-dictionary-transform :value="scope.row.methodType"
                                     type="deviceOperationType"
                                     :key="scope.row.id + scope.row.methodType"></zk-dictionary-transform>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('common.action')">
          <template slot-scope="scope">
            <el-button size="mini"
                       @click.stop="toggleRowExpansion(scope.row)">{{ $t('common.details') }}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column width="1px"
                         type="expand">
          <template slot-scope="props">
            <div class="arrow_icon"></div>
            <div class="arrow_icon2"></div>
            <el-card class="logDeatil_cla">
              <div class="logItem_cla">
                <div class="logItem_label">{{ $t('device.log.requestParams') }}:</div>
                <div class="logItem_value">{{ props.row.requestParams }}</div>
              </div>
            </el-card>
          </template>
        </el-table-column> -->
      </el-table>
    </el-row>
    <el-drawer :with-header="false"
               :visible.sync="drawer"
               direction="rtl">
      <el-tabs @tab-click="tabClick"
               class="com_log_tabs_cla"
               v-model="activeName"
               type="card">
        <el-tab-pane :label="$t('device.log.requestParams')"
                     name="first">
          <json-viewer :expand-depth="10"
                       class="associatedLog_json_cla"
                       :value="isJson(associatedLog)"></json-viewer>
        </el-tab-pane>
      </el-tabs>

    </el-drawer>
    <div style="margin-top:15px">
      <el-pagination background
                     @size-change="changePageSize"
                     @current-change="changePage"
                     :current-page="pager.curPage"
                     :page-size="pager.pageSize"
                     :total="pager.total"
                     layout="total, prev, pager, next, sizes, jumper"></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryDeviceLog } from '@/services/deviceApi.js'
import pickerOptions from '@/utils/pickerOptions.js'
import { getStartTime, getEndTime } from '@/utils/utils.js'
import JsonViewer from 'vue-json-viewer'
export default {
  data () {
    return {
      pickerOptions: pickerOptions(this),
      value2: [],
      params: {
        devSn: '',
        methodType: ''
      },
      expands: [],
      tableData: [],
      drawer: false,
      associatedLog: '',
      activeName: 'first'
    }
  },
  props: {
    devSn: {
      type: String,
      default: ''
    },
    contentHeight: {
      type: Number,
      default: 500
    }
  },
  watch: {
    'devSn': {
      handler: function (val, oVal) {
        if (val) {
          this.params.devSn = val
          this.pager.curPage = 1
          this.pager.total = 0
          this.loadDeviceLog()
        } else {
          this.tableData = []
        }
      },
      deep: true
    }
  },
  mounted () {
    if (this.devSn) {
      this.params.devSn = this.devSn
      this.loadDeviceLog()
    }
  },
  components: { JsonViewer },
  methods: {
    isJson (str) {
      try {
        return JSON.parse(str, (key, value) => {
          return this.isJson(value)
        })
      } catch (err) {
        return str
      }
    },
    getRowKeys (row) {
      return row.id
    },
    toggleRowExpansion (row) {
      this.drawer = true
      this.associatedLog = row.requestParams
      console.log(this.associatedLog)
      // if (this.expands.length > 0 && this.expands[0] === row.id) {
      //   this.expands = []
      // } else {
      //   this.expands = []
      //   this.expands.push(row.id)
      // }
    },
    changePage (current) {
      this.pager.curPage = current
      this.loadDeviceLog()
    },
    changePageSize (pageSize) {
      this.pager.pageSize = pageSize
      this.loadDeviceLog()
    },
    searchFn () {
      this.pager.curPage = 1
      this.loadDeviceLog()
    },
    loadDeviceLog () {
      if (this.value2 && this.value2.length === 2) {
        this.params.beginDate = getStartTime(this.value2[0])
        this.params.endDate = getEndTime(this.value2[1])
      } else {
        this.params.beginDate = ''
        this.params.endDate = ''
      }
      queryDeviceLog({
        params: this.params,
        pager: this.pager
      })
        .then((data) => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results

            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords

            this.pager.curPage =
              data.payload.results.curPage || data.payload.curPage

            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords

            this.pager.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((e) => {
          this.errorMessage()
        })
    }
  }
}
</script>
<style lang="less">
/deep/ .el-table__expand-icon > .el-icon {
  display: none;
}
.device_history_cla {
  .el-date-editor--datetimerange.el-input__inner {
    width: 230px;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .arrow_icon {
    position: absolute;
    top: -20px;
    right: 9.5%;
    width: 0px;
    height: 0px;
    border: 20px solid;
    border-color: transparent transparent #a99e9e transparent;
  }
  .arrow_icon2 {
    position: absolute;
    top: -18px;
    z-index: 1000;
    right: 9.5%;
    width: 0px;
    height: 0px;
    border: 20px solid;
    border-color: transparent transparent #eceaea transparent;
  }
  .logDeatil_cla {
    position: relative;
    background: #eceaea;
    border-radius: 20px;
    border: 1px solid #a99e9e;
    width: 98%;
    margin: 20px auto;
  }
  .logItem_cla {
    line-height: 1.5;
    .logItem_label {
      float: left;
      padding-right: 10px;
      font-size: 12px;
      color: #333333;
      text-align: right;
      width: 80px;
    }
    .logItem_value {
      display: flow-root;
      // word-break: break-word;
      word-break: break-all;
      font-size: 12px;
      color: #999999;
    }
  }
}
.name-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/deviceHistoryLog.vue